import axios from 'axios';
import store from '../store';

const ecpUrl = (path) => {
    const baseUrl = store.getters['settings/from'].ecpPlatformUrl;
    return `${baseUrl}/${path}`;
}

const crmUrl = (path) => {
    return `https://crm-server.multiversity.click/${path}`;
}

const restUrl = (path) => {
    const baseUrl = `https://server.rest-sites.multiversity.click/${store.getters['settings/from'].api}`;
    return `${baseUrl}/${path}`;
}

const req = (fn, method, path, data, options) => {
    return axios({
        method,
        url: fn(path),
        data,
        ...options,
    });
}

const get = (fn, path, options = null) => {
    return req(fn, 'get', path, null, options);
}

const post = (fn, path, data, options = null) => {
    return req(fn, 'post', path, data, options);
}

export const ecp = {
    get: (...args) => {
       return get.apply(null, [ecpUrl, ...args])
    },
    post: (...args) => {
        return post.apply(null, [ecpUrl, ...args])
    }
}

export const crm = {
    get: (...args) => {
        return get.apply(null, [crmUrl, ...args])
    },
    post: (...args) => {
        return post.apply(null, [crmUrl, ...args])
    }
}